import { BASE_URL } from "@/constants/config";
import { request } from "@/utils/request";

export const TASKS_ENDPOINTS = {
  task: (taskId) => `${BASE_URL}api/tasks/${taskId}`,
};

export default class Task {
  eventHandlers = {};

  constructor(taskId, extractor='json') {
    this.taskId = taskId;
    this.extractor = extractor
    this.checkTaskStatus();
  }

  on(eventName, callback) {
    this.eventHandlers[eventName] = callback;
  }

  checkTaskStatus = async () => {
    let response;
    try {
      response = await request({
        url: TASKS_ENDPOINTS.task(this.taskId),
        query: {extract_option: this.extractor}
      });
    } catch (e) {
      return (
        this.eventHandlers.error && this.eventHandlers.error({ exception: e })
      );
    }

    const { data } = response;
    if (data.status === "SUCCESS") {
      this.eventHandlers.result && this.eventHandlers.result?.(data.result);
    } else if (data.status === "FAILURE") {
      this.eventHandlers.error && this.eventHandlers.error?.(data.error);
    } else if (
      !data.status && response.headers && response.headers.get('content-type').includes('spreadsheetml.sheet')
    ) {
      this.eventHandlers.result && this.eventHandlers.result?.(response.res);
    }
    else {
      this.eventHandlers.progress &&
        this.eventHandlers.progress({
          ...data,
          taskId: this.taskId,
          progress: data.progress || 0,
        });
      setTimeout(this.checkTaskStatus, 250);
    }
  };
}
